import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HideIfSubChatDirective } from './hide-if-sub-chat.directive';
import { ShowIfHasPrivilegeDirective } from './show-if-has-privilege.directive';
import { CancelActionIfNotSubscribedDirective } from './cancel-action-if-not-subscribed.directive';
import { CancelClickIfNotSubscribedDirective } from './cancel-click-if-not-subscribed.directive';
import { HideIfMainChatDirective } from './hide-if-main-chat.directive';
import { AppCancelActionIfNotHasPrivilegeDirective } from './cancel-action-if-not-has-privilege.directive';
import { ShowIfHasPrivilegeModuleDirective } from './show-if-has-privilege-module.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    HideIfSubChatDirective,
    ShowIfHasPrivilegeModuleDirective,
    ShowIfHasPrivilegeDirective,
    CancelActionIfNotSubscribedDirective,
    CancelClickIfNotSubscribedDirective,
    HideIfMainChatDirective,
    AppCancelActionIfNotHasPrivilegeDirective
  ],
  exports: [
    HideIfSubChatDirective,
    ShowIfHasPrivilegeModuleDirective,
    ShowIfHasPrivilegeDirective,
    CancelActionIfNotSubscribedDirective,
    CancelClickIfNotSubscribedDirective,
    HideIfMainChatDirective,
    AppCancelActionIfNotHasPrivilegeDirective
  ]
})
export class AccessorsModule {}
